<template>
  <div class="f-tag-field f-tag-field--lg">
    <div class="f-tag-field__tags">
      <div
        v-for="(tag, idx) in modelValue"
        :key="tag"
        :data-tag="tag"
        :draggable="true"
        class="f-tag-field__tag"
      >
        <span>
          {{ tag }}
        </span>
        <button
          type="button"
          class="f-tag-field__tag-remove"
          :aria-label="$t('actions.remove')"
          @click="removeTag(idx)"
        />
      </div>
      <input
        :id="`record.${fieldName}`"
        v-model="currentValue"
        :placeholder="currentValue !== null ? '' : placeholder"
        class="f-tag-field__input"
        type="number"
        autocomplete=""
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        @input="setCurrentValue"
        @keypress.enter.prevent="addTag"
      >
      <Transition name="validation-fade">
        <p
          v-if="error && error.message"
          class="f-field__validation u-text-danger"
        >
          {{ error.message }}
        </p>
      </Transition>
    </div>
    <div class="f-tag-field__hint subject-field__hint">
      <span>
        {{ $t(`advancedsearch.fields.${fieldName}.hint`) }}
      </span>
      <svg
        width="25"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          fill="none"
          fill-rule="evenodd"
        >
          <rect
            stroke="var(--gray-400)"
            fill="var(--light-gray-300)"
            x=".5"
            y=".5"
            width="24"
            height="17"
            rx="2"
          />
          <g
            stroke="var(--gray)"
            stroke-linecap="round"
            stroke-width="1.2"
          >
            <path
              stroke-linejoin="round"
              d="M8 10.5h9v-4h-3"
            />
            <path d="M10 12.5l-2-2 2-2" />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { MetadataUtils } from '@scholar/metadata-utils/main'

export default {
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  data() {
    return {
      currentValue: 0,
      validation: { status: true },
      parser: new MetadataUtils().getParserByType(this.recordType)
    }
  },
  computed: {
    placeholder() {
      if (this.$te(`advancedsearch.fields.${this.fieldName}.placeholder`)) {
        return this.$t(`advancedsearch.fields.${this.fieldName}.placeholder`)
      } else {
        return this.$t(`fields.record.${this.fieldName}.placeholder`)
      }
    },
    error() {
      return this.validation.status ? {} : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.field?.error}`) }
    }
  },
  watch: {
    modelValue: async function (newValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {
    async setCurrentValue() {
      if (!/^-?[0-9]+$/.test(this.currentValue)) {
        this.currentValue = 0
      } else {
        this.currentValue = Number(this.currentValue)
      }
      await this.validate()
    },
    async addTag() {
      if (!this.modelValue.includes(this.currentValue) && this.validation.status) {
        this.value.push(this.currentValue)
        this.$emit('change', this.modelValue)
      }
      if (this.validation.status) {
        this.currentValue = 0
      }
    },
    removeTag(idx) {
      this.modelValue.splice(idx, 1)
      this.$emit('change', this.modelValue)
    },
    async validate() {
      this.validation = await this.parser.validateByField(this.validatorName || this.fieldName, this.currentValue)
    }
  }
}
</script>
<style lang="scss">
.subject-field__hint {
  span + svg {
    margin-left: 0.5rem;
  }
}
</style>
